<template>
<div class="MAgencyView m-agency" v-if="init">
    <!--<div class="m-header" :style="item.hostinfo.bannerlist.length?'background:url('+item.hostinfo.bannerlist[0].bannerlogourl+');background-repeat:no-repeat;background-size:100% 100%;':''">-->
    <div class="m-header" :style="'background:url('+imgAgency+');background-repeat:no-repeat;background-size:100% 100%;'">
        <div class="top">
            <div class="agency-logo">
                <img class="img" v-lazy="item.hostinfo.hostlogourl" alt="">
                <span class="blod">{{item.hostinfo.hostname}}</span>
            </div>
            <div class="follow" @click="handleFollow">
                <span v-if="!item.isfavorite">+ 关注</span>
                <span v-else>已关注</span>
            </div>
        </div>
        <div class="bottom">
            <div class="box">
                <div class="name">课程数</div>
                <div class="value">{{item.hostinfo.coursecount}}</div>
            </div>
            <div class="box">
                <div class="name">题库数</div>
                <div class="value">{{item.hostinfo.qbcount}}</div>
            </div>
            <div class="box">
                <div class="name">学生数</div>
                <div class="value">{{item.hostinfo.studentcount}}</div>
            </div>
            <div class="box">
                <div class="name">好评度</div>
                <div class="value">{{item.hostinfo.commentrate}}%</div>
            </div>
        </div>
    </div>
    <div class="m-body" ref="tabs">
        <van-tabs @change="tabChange" v-model="param.type" animated sticky color="#409EFF" title-active-color="#409EFF"
                  title-inactive-colo="#666666">
            <van-tab title="课程">
                <MCourseList :item="item"></MCourseList>
            </van-tab>
            <van-tab title="题库">
                <MBankList :item="item"></MBankList>
            </van-tab>
            <van-tab title="老师">
                <MTeacherList :item="item"></MTeacherList>
            </van-tab>
            <van-tab title="关于">
                <MAboutAgency :item="item"></MAboutAgency>
            </van-tab>
        </van-tabs>
    </div>
    <div class="serve icon-serve" @click="openService" v-if="item.withinfo.serviceqrurl"></div>
    <Popup :pop="service" ref="service">
        <div class="contact">
            <div class="tel">电话：{{item.withinfo.linktel}}</div>
            <!--<div class="email">邮箱：{{item.withinfo.linkemail}}</div>-->
        </div>
    </Popup>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getMCourseHostDetailInfo, uploadCourseHostFollow} from 'api/api'
import MCourseList from 'views/mobile/sort/agency/components/mCourseList'
import MBankList from 'views/mobile/sort/agency/components/mBankList'
import MTeacherList from 'views/mobile/sort/agency/components/mTeacherList'
import MAboutAgency from 'views/mobile/sort/agency/components/mAboutAgency'
import Popup from 'views/mobile/components/popup/popup'
export default {
    name: 'MAgencyView',
    data() {
        return {
            imgAgency: require('@/common/images/msort/img-agency.png'),
            init: false,
            param: {
                hostid: this.$route.query.hostid ? this.$route.query.hostid : '',
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            item: {
                hostfreecourselist: [],
                isfavorite: 0,
                hostinfo: {
                    bannerlist: [],
                    coursecount: 0,
                    hostid: '',
                    hostlogourl: '',
                    hostname: '',
                    studentcount: 0,
                    commentrate: '',
                    teachercount: 0
                },
                hostnewcourselist: [],
                hostteacherlist: [],
                withinfo: {}
            },
            service: {
                url: '',
                title: '',
                tip: [],
                isSave: false
            }
        }
    },
    mounted() {
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'OrganIndex',
                query: {
                    hostid: this.$route.query.hostid,
                    chid: this.$route.query.chid ? this.$route.query.chid : ''
                }
            })
        }
        this.setNoDataTip('当前机构暂无课程')
        if (!this.refresh)  this.getView()
    },
    activated() {
        if (this.refresh)  {
            this.param.hostid = this.$route.query.hostid ? this.$route.query.hostid : ''
            this.getView()
            this.setRefresh(false)
        }
    },
    methods: {
        // 机构导航tab切换
        tabChange(e, event) {
            // console.log(e)
            // console.log(event)
            if (event==='课程') {
                this.setNoDataTip('当前机构暂无课程')
            }
            if (event==='题库') {
                this.setNoDataTip('当前机构暂无题库')
            }
            if (event==='老师') {
                this.setNoDataTip('当前机构暂无老师')
            }
            if (event==='关于') {
                this.setNoDataTip('当前机构暂无简介')
            }
        },
        openService() {
            this.$refs.service.open()
        },
        handleFollow() { // 1 关注 2 取消关注
            let optype = this.item.isfavorite ? 2 : 1
            this.setLoading(true)
            uploadCourseHostFollow({
                data: Object.assign({}, this.param, {optype: optype}),
                success: () => {
                    this.setLoading(false)
                    this.$toast.success('操作成功！')
                    this.item.isfavorite = !this.item.isfavorite
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        getView() {
            this.setLoading(true)
            getMCourseHostDetailInfo({
                data: this.param,
                success: data => {
                    this.setLoading(false)
                    this.init = true
                    this.item = data.data
                    this.service.url = this.item.withinfo.serviceqrurl
                    this.service.tip = [this.item.withinfo.servicename]
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setNoDataTip', 'setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh', 'domainInfo'])
    },
    components: {
        MCourseList, MBankList, MTeacherList, MAboutAgency, Popup
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~views/mobile/sort/agency/agency";
.MAgencyView {
    .m-header {
        .top {
            .follow {
                width: 1.22rem;
                height: 0.46rem;
                border-radius: 0.23rem;
                background: rgba(255, 255, 255, 0.3);
                border: 0.01rem solid rgba(255, 255, 255, 1);
                line-height: 0.46rem;
                text-align: center;
                font-size: 0.26rem;
            }
        }
    }
    .m-body {
        .van-tab__pane{
            /*max-height: calc(100vh - 0.8rem);*/
            /*overflow: scroll;*/
            min-height: calc(100vh - 0.8rem);
            padding-top: 0.1rem;
        }
        .van-tabs__wrap {
            height: 0.8rem;
            box-sizing: border-box;
            padding: 0.1rem 0;
            background: $c-white;
        }
        .van-tab {
            height: 0.6rem;
            line-height: 0.6rem;
        }
        .van-tab__text {
            font-size: 0.28rem;
        }
    }
    .van-tabs__line{
        height: 0.04rem;
    }
    .noData{
        /*height: calc(100vh - 4.1rem);*/
        height: calc(100vh - 0.8rem);
        background: $c-white;
        .tip{
            margin-bottom: 4rem;
        }
    }
    .noData+.van-list__finished-text{
        display: none;
    }
}
</style>